import React, { useState } from 'react';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faTimes, faSave, faImage } from '@fortawesome/free-solid-svg-icons';
import GalleryBrowser from '../Galleries/GalleryBrowser';
import './PagePropertiesModal.css';

const PagePropertiesModal = ({ page, onClose, onSave, galleries }) => {
    const [formData, setFormData] = useState({
        name: page.title || '',
        welcomeTitle: page.welcomeTitle || '',
        description: page.description || '',
        headerBannerImage: page.headerBannerImage || '',
        isPublished: page.isPublished || false
    });

    const [showImageBrowser, setShowImageBrowser] = useState(false);

    const handleChange = (e) => {
        const { name, value, type, checked } = e.target;
        setFormData(prev => ({
            ...prev,
            [name]: type === 'checkbox' ? checked : value
        }));
    };

    const handleImageSelect = (selectedImage) => {
        setFormData(prev => ({
            ...prev,
            headerBannerImage: selectedImage.url
        }));
        setShowImageBrowser(false);
    };

    const handleSubmit = (e) => {
        e.preventDefault();
        onSave({ ...page, ...formData });
    };

    return (
        <>
            <div className="modal-overlay" onClick={onClose}></div>
            <div className="page-properties-modal">
                <div className="modal-header">
                    <h2>Page Properties - {page.title}</h2>
                    <button className="close-button" onClick={onClose}>
                        <FontAwesomeIcon icon={faTimes} />
                    </button>
                </div>

                <form onSubmit={handleSubmit}>
                    <div className="form-section">
                        <div className="form-group">
                            <label>Page Name</label>
                            <input
                                type="text"
                                name="name"
                                value={formData.name}
                                onChange={handleChange}
                                required
                            />
                        </div>

                        <div className="form-group">
                            <label>Welcome Title</label>
                            <input
                                type="text"
                                name="welcomeTitle"
                                value={formData.welcomeTitle}
                                onChange={handleChange}
                                placeholder="Welcome to..."
                            />
                        </div>

                        <div className="form-group">
                            <label>Description</label>
                            <textarea
                                name="description"
                                value={formData.description}
                                onChange={handleChange}
                                rows="3"
                                placeholder="Enter page description..."
                            />
                        </div>

                        <div className="form-group">
                            <label>Welcome Header Banner</label>
                            <div className="media-browse">
                                <input
                                    type="text"
                                    value={formData.headerBannerImage}
                                    readOnly
                                    placeholder="No image selected"
                                />
                                <button 
                                    type="button" 
                                    className="btn-browse"
                                    onClick={() => setShowImageBrowser(true)}
                                >
                                    <FontAwesomeIcon icon={faImage} /> Browse
                                </button>
                            </div>
                            {formData.headerBannerImage && (
                                <div className="media-preview">
                                    <img src={formData.headerBannerImage} alt="Header Banner Preview" />
                                </div>
                            )}
                        </div>
                    </div>

                    <div className="form-group checkbox">
                        <label>
                            <input
                                type="checkbox"
                                name="isPublished"
                                checked={formData.isPublished}
                                onChange={handleChange}
                            />
                            Published
                        </label>
                    </div>

                    <div className="modal-footer">
                        <button type="button" className="btn-secondary" onClick={onClose}>
                            Cancel
                        </button>
                        <button type="submit" className="btn-primary">
                            <FontAwesomeIcon icon={faSave} /> Save Changes
                        </button>
                    </div>
                </form>
            </div>

            {showImageBrowser && (
                <GalleryBrowser
                    galleries={galleries}
                    mediaType="image"
                    onSelect={handleImageSelect}
                    onClose={() => setShowImageBrowser(false)}
                />
            )}
        </>
    );
};

export default PagePropertiesModal; 